import dayjs from 'dayjs';
import { Policy } from 'models/policies';

// Helper function to determine if a policy is within the active period
export const isWithinActivePeriod = (policy: Policy): boolean => {
  if (policy.status !== 'CANCELED') {
    return true;
  }

  const activeUntil = policy.attributes?.activeUntil;
  if (!activeUntil) {
    return true; // If no activeUntil date is available, we show the button to be safe
  }

  return dayjs().isBefore(dayjs(activeUntil).add(2, 'year'));
};
